"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttachedDocs = void 0;

var _react = _interopRequireDefault(require("react"));

var _ListItem = _interopRequireDefault(require("./ListItem"));

var _AttachedDocs = require("./AttachedDocs.styled");

var AttachedDocs = function AttachedDocs(_ref) {
  var attachmentData = _ref.attachmentData;
  return /*#__PURE__*/_react.default.createElement(_AttachedDocs.AttachedDocsWrapper, null, /*#__PURE__*/_react.default.createElement("h3", null, "Attached Documents"), /*#__PURE__*/_react.default.createElement("div", {
    className: "attachment-list"
  }, attachmentData && attachmentData.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      item: item
    });
  })));
};

exports.AttachedDocs = AttachedDocs;